export const htmlLegendPlugin = {
  id: "htmlLegend",
  afterUpdate(chart: any) {
    const container = document.getElementById("legend-container");
    if (!container) return;

    while (container.firstChild) {
      container.firstChild.remove();
    }

    const list = document.createElement("ul");
    list.className = "flex flex-wrap gap-2";

    chart.data.datasets.forEach((dataset: any, i: number) => {
      const item = document.createElement("li");
      item.className = "cursor-pointer text-sm flex items-center gap-2";
      item.onclick = () => {
        chart.setDatasetVisibility(i, !chart.isDatasetVisible(i));
        chart.update();
      };

      const box = document.createElement("span");
      box.style.background = dataset.backgroundColor;
      box.style.width = "12px";
      box.style.height = "12px";
      box.style.display = "inline-block";
      box.style.borderRadius = "2px";

      const text = document.createTextNode(dataset.label);
      item.appendChild(box);
      item.appendChild(text);

      list.appendChild(item);
    });

    container.appendChild(list);
  },
};
